import PropTypes from 'prop-types';
import { createContext, useState } from 'react';
// @mui
import { CssBaseline } from '@mui/material';
import { ThemeProvider as MUIThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
//
import palette from './palette';
import shadows from './shadows';
import typography from './typography';
import GlobalStyles from './globalStyles';
import customShadows from './customShadows';
import componentsOverride from './overrides';
import { border } from '@chakra-ui/react';

// ----------------------------------------------------------------------

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

export const ThemeContext = createContext({
  mode: '',
  setMode: (props) => { },
});

export default function ThemeProvider({ children }) {
  const [mode, setMode] = useState('light');


  const theme = createTheme({
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            WebkitFontSmoothing: 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: mode === 'light' ? palette.grey[500_32] : `${palette.common.white} ${palette.grey[900]}`,
            scrollbarTrackColor: mode === 'light' ? palette.grey[500_32] : `${palette.common.white} ${palette.grey[900]}`,
            backgroundColor: mode === 'dark' ? '#312d3b' : palette.background.default,
          },
          header: {
            backgroundColor: mode === 'dark' ? '#303030' : '#333f48',
          },
      
          '.p-fileupload-content': {
            backgroundColor: mode === 'dark' ? '#171717' : 'inherit',
          },
          '.p-fileupload-buttonbar': {
            backgroundColor: mode === 'dark' ? '#171717' : 'inherit',
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: mode === 'dark' ? '#303030' : '#333f48',
          },
        },
      },
      MuiStack: {
        styleOverrides: {
          root: {
            color: mode === 'dark' ? '#fff' : '#000', // Conditional text color
          },
        },
      },
    },
    palette: {
      primary: {
        main: mode === 'dark' ? '#f9f9f9' : '#333f48',
      },
      // secondary: {
      //   main: '#f44336',
      // },
      mode: mode,
      background: {
        default: mode === 'dark' ? '#312d3b' : '#fff',
        paper: mode === 'dark' ? '#312d3b' : '#fff',
      },
      action: {
        selected: mode === 'dark' ? '#494358' : 'rgba(145, 158, 171, 0.16)',
      },
    },
    shape: { borderRadius: 6 },
    typography,
    shadows: shadows(),
    customShadows: customShadows(),
  });
  // theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        <ThemeContext.Provider value={{
          mode,
          setMode
        }}>
          {children}
        </ThemeContext.Provider>
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
